export const LOAD_TIMESHEET_SUCCESS = "LOAD_TIMESHEET_SUCCESS";
export const CREATE_TIMESHEET_SUCCESS = "CREATE_TIMESHEET_SUCCESS";
export const UPDATE_TIMESHEET_SUCCESS = "UPDATE_TIMESHEET_SUCCESS";


/** WEBPACK FOOTER **
 ** ./src/container/TimeSheetContainer/constants.js
 **/